module.exports = __webpack_public_path__ + "static/media/macacaoSincronizada.85846db3.jpg";